// extracted by mini-css-extract-plugin
export default {"root":"XpbrK","content":"_22G0C"};